/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleInput/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Option from './Option/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ToggleInput({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion/ListInput/ToggleInput",
  disabled,
  size,
  maxWidth,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  showAlert
  
}) {
let questionNameValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'name',
})
let dtTysiainputlabelColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputLabel.color.primary.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let listOptionsValueData = fromData.useDataValue({ viewPath,
context: 'list',
path: 'options',
})
  return (<React.Fragment
>
<div
  data-testid="ToggleInput.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="question.name"
 text={questionNameValueData}
 color={dtTysiainputlabelColorPrimaryBase}
 fontWeight={600}
 whiteSpace="nowrap"
 overflowX="hidden"
 textOverflow="ellipsis"
 marginTop={dtSpaceXs}
/>
<div
  data-testid="ToggleInput.List"
  data-view-path={viewPath}
 className={`views-block ${styles.List}`}
>
{Array.isArray(listOptionsValueData) && listOptionsValueData.map((item, index, list) => 
<ListItem
        key={`${item?.id}`}
        context="option"
        item={item}
        index={index}
        list={list}
        hasItemKey={true}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Option(${`${item?.id}`})`}
      >
<Option
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Option(${`${item?.id}`})`}
 disabled={disabled}
 size={size}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 showAlert={showAlert}
/>
</ListItem>
)}
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }